'use strict';

exports.__esModule = true;
exports.render = render;
exports.replaceUnsafeCharsInJson = replaceUnsafeCharsInJson;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _TagTypes = require('../types/TagTypes');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var LINK = _TagTypes.TAG_TYPES.LINK,
    META = _TagTypes.TAG_TYPES.META,
    SCRIPT = _TagTypes.TAG_TYPES.SCRIPT,
    TITLE = _TagTypes.TAG_TYPES.TITLE;

/**
 * Renders given tag list to an array of react components.
 * If tag is not supported, then it will be ommited from results.
 *
 * @summary Renders given tag list to an array of react components.
 * @param {Array} tags to render.
 */

function render(tags) {
  if (!Array.isArray(tags)) {
    return [];
  }
  return tags.map(function (tag) {
    var type = (tag || {}).type;
    if (type === TITLE) return renderTitle(tag);
    if (type === META) return renderMeta(tag);
    if (type === LINK) return renderLink(tag);
    if (type === SCRIPT) return renderScript(tag);
    return null;
  }).filter(function (_) {
    return _;
  });
}

function renderTitle(_ref) {
  var children = _ref.children;

  return React.createElement(
    'title',
    null,
    isValid(children) ? children : ''
  );
}

function renderMeta(_ref2) {
  var props = _ref2.props;

  return React.createElement('meta', filterValidProps(props));
}

function renderLink(_ref3) {
  var props = _ref3.props;

  return React.createElement('link', filterValidProps(props));
}

function renderScript(_ref4) {
  var props = _ref4.props,
      children = _ref4.children;

  var type = (props || {}).type;
  if (type === 'application/ld+json' && isValidJson(children)) {
    var data = JSON.stringify(JSON.parse(children));
    return React.createElement('script', {
      type: 'application/ld+json',
      dangerouslySetInnerHTML: { __html: replaceUnsafeCharsInJson(data) }
    });
  }
  return null;
}

function filterValidProps(props) {
  return Object.keys(props || {}).reduce(function (acc, name) {
    if (isValid(props[name])) {
      acc[name] = props[name];
    }
    return acc;
  }, {});
}

function isValidJson(value) {
  try {
    return isValid(value) && !!JSON.parse(value);
  } catch (error) {
    return false;
  }
}

function isValid(value) {
  return typeof value === 'string';
}

function replaceUnsafeCharsInJson(json) {
  var escapedChars = {
    '<': '\\u003C',
    '>': '\\u003E',
    '/': '\\u002F',
    '\u2028': '\\u2028',
    '\u2029': '\\u2029'
  };
  return json.replace(/[<>/\u2028\u2029]/g, function (unsafeChar) {
    return escapedChars[unsafeChar];
  });
}